import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid size-full place-items-center text-center" }
const _hoisted_2 = { class: "flex flex-col py-20" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "mb-8 text-[22px] font-bold leading-none" }

import { inject } from 'vue';
import useBgImage from '../composables/useBgImage';
import Button from '../components/base/Button.vue';
import { AppConfigType } from '../types';
import usePopupWindow from '../composables/usePopupWindow';
import { useRouter } from 'vue-router';
import useSetPageTitle from '../composables/useSetPageTitle';
import { useGettext } from 'vue3-gettext';

// Translations

export default /*@__PURE__*/_defineComponent({
  __name: 'CreateAccount',
  setup(__props) {

const { $gettext } = useGettext();

// Set page title
useSetPageTitle($gettext('Create account'));

// Get plugin config
const config: AppConfigType = inject('pluginConfig');

// Router
const router = useRouter();

// Set backgroud image on body
useBgImage(config.plugin_url);

// Show popup with login
const openAuthorizationPopup = () => {
    // Construct url
    const url = `https://boostsite.com/wp?url=${config.home_url}&screen_hint=signup`;

    // Show window
    usePopupWindow(url, 500, 700, () => {
        // Refresh the page
        router.go(0);
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        width: "143px",
        class: "mx-auto mb-8",
        src: `${_unref(config).plugin_url}/public/images/boostsite-logo.png`
      }, null, 8, _hoisted_3),
      _createElementVNode("h1", _hoisted_4, _toDisplayString(_unref($gettext)('Create account')), 1),
      _createVNode(Button, {
        class: "w-[320px]",
        text: _unref($gettext)('Sign up'),
        size: "large",
        onClick: _withModifiers(openAuthorizationPopup, ["prevent"])
      }, null, 8, ["text"])
    ])
  ]))
}
}

})